const baseRoute = 'environmental-aspects-assessment/:moduleBridgeHex/:plantHex/';
export default {
  user_module_environmentalAspectsAssessment_assessment_current: {
    path: `${baseRoute}assessment/current/`,
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: 0,
    },
  },
  user_module_environmentalAspectsAssessment_assessment_home: {
    path: `${baseRoute}assessment/home/:assessmentHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: 0,
      assessmentHex: 0,
    },
  },
  user_module_environmentalAspectsAssessment_assessment_log_list: {
    path: `${baseRoute}assessment/log/list/`,
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: 0,
    },
  },
  user_module_environmentalAspectsAssessment_inspection_list: {
    path: `${baseRoute}inspection/list/`,
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: 0,
      assessmentHex: 0,
    },
  },
  user_module_environmentalAspectsAssessment_inspection_home: {
    path: `${baseRoute}inspection/home/:assessmentHex/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      plantHex: 0,
      assessmentHex: 0,
      filtersHex: 0,
    },
  },
};
